// Putting logout because of no activity
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toastMessage } from "../utils/toastMessage";

// this code is created an instance with base url for admin
// const url =
export const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const getToken = (key = "cashsurvey_admin") => {
  const cashsurveyAdminInfo = localStorage.getItem(key);
  return cashsurveyAdminInfo ? JSON.parse(cashsurveyAdminInfo) : null;
};

export const setJwtToken = (tokenKey = "cashsurvey_admin") => {
  const token = getToken(tokenKey);
  if (!token) {
    console.error("Token is missing or invalid");
    return {};
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  };
};

export const setMultiPartHeader = () => {
  const token = getToken();
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
    },
  };
};

export const removeToken = () => {
  const keys = ["cashsurvey_admin", "admin-detail", "admin-permission"];
  keys.forEach((key) => localStorage.removeItem(key));
};

// this interceptors checks user's token is valid or not
export const AxiosInterceptor = ({ children }) => {
  const [isSet, setIsSet] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const resInterceptor = (response) => {
      if (response?.data?.status === 401) {
        removeToken();
        navigate("/");
      }
      return response;
    };

    const errInterceptor = (error) => {
      const { response: { data } = {}, code } = error;

      // Handle network errors (e.g., server unreachable, connection refused)
      if (code === "ERR_NETWORK" || code === "ERR_CONNECTION_REFUSED") {
        toastMessage(
          "Connection error. Please check your network or server.",
          "error",
          "networkError"
        );
        return Promise.reject(error);
      }

      if (data && data?.status !== 200) {
        toastMessage(data?.message, "error", "errorMeesage");
        return Promise.reject(error);
      }
    };

    const interceptor = instance.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );
    setIsSet(true);

    return () => instance.interceptors.response.eject(interceptor);
    // eslint-disable-next-line
  }, []);

  return isSet && children;
};

// const LOGOUT_TIME = 1000 * 60 * 5; // 5 min.
// const events = ["mousemove", "mousedown", "keydown", "scroll"]; // adding events for inactivity

// export const AppLogout = ({ children }) => {
//   const location = useLocation();
//   const navigate = useNavigate();
//   const logoutTimer = useRef(null);

//   const lastInteractionTime = useRef(
//     parseInt(localStorage.getItem("lastInteractionTime")) || Date.now()
//   );

//   const handleLogout = () => {
//     toastMessage("Session Expired. Please login again.", "error", "Inactivity");
//     localStorage.clear();
//     navigate("/");
//   };

//   const resetTimer = () => {
//     clearTimeout(logoutTimer.current);
//     logoutTimer.current = setTimeout(logoutIfInactive, LOGOUT_TIME);
//   };

//   const logoutIfInactive = () => {
//     const currentTime = Date.now();
//     if (currentTime - lastInteractionTime.current >= LOGOUT_TIME) {
//       handleLogout();
//     } else {
//       resetTimer();
//     }
//   };

//   const recordInteraction = () => {
//     lastInteractionTime.current = Date.now();
//     localStorage.setItem("lastInteractionTime", lastInteractionTime.current);
//   };

//   const onFocus = () => {
//     recordInteraction();
//     resetTimer();
//   };

//   const onVisibilityChange = () => {
//     if (!document.hidden) {
//       const timeSinceLastInteraction = Date.now() - lastInteractionTime.current;
//       if (timeSinceLastInteraction >= LOGOUT_TIME) {
//         handleLogout();
//       } else {
//         resetTimer();
//       }
//     } else {
//       clearTimeout(logoutTimer.current);
//     }
//   };

//   const addEventListeners = () => {
//     events.forEach((event) => {
//       window.addEventListener(event, recordInteraction);
//     });
//     window.addEventListener("focus", onFocus);
//     document.addEventListener("visibilitychange", onVisibilityChange);
//   };

//   const removeEventListeners = () => {
//     events.forEach((event) => {
//       window.removeEventListener(event, recordInteraction);
//     });
//     window.removeEventListener("focus", onFocus);
//     document.removeEventListener("visibilitychange", onVisibilityChange);
//   };

//   // useEffect(() => {
//   //   if (location.pathname !== "/") {
//   //     addEventListeners();
//   //     resetTimer();
//   //   }

//   //   return () => {
//   //     removeEventListeners();
//   //     clearTimeout(logoutTimer.current);
//   //   };
//   // }, [location.pathname]);

//   return children;
// };
